import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconTextColumnBreak16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconTextColumnBreak16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M7 4a1 1 0 0 1 1-1h1.5a.5.5 0 0 1 0 1H8v9a1 1 0 0 1-1 1H5.5a.5.5 0 0 1 0-1H7zM1 5.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5M1.5 9a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zM1 7.5a.5.5 0 0 1 .5-.5H3a.5.5 0 0 1 0 1H1.5a.5.5 0 0 1-.5-.5m.5 3.5a.5.5 0 0 0 0 1H3a.5.5 0 0 0 0-1zM11 5.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5m.5 3.5a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zM11 7.5a.5.5 0 0 1 .5-.5H13a.5.5 0 0 1 0 1h-1.5a.5.5 0 0 1-.5-.5m.5 3.5a.5.5 0 0 0 0 1H13a.5.5 0 0 0 0-1z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconTextColumnBreak16);
